import React, { useEffect, useState } from "react";
import { Else, If } from "react-condition";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import CandidateSingleView from "../../../components/CandidateSingleView";

function LoadingModalHeader() {
  return <ModalHeader>Candidate is being loaded</ModalHeader>;
}

function LoadingModalBody() {
  return <ModalBody>Candidate Data is still being loaded.</ModalBody>;
}

function CandidateModal({ modal, toggleModal, candidate, setCandidate }) {
  let nextCandidate = candidate.nextCandidate;
  let previousCandidate = candidate.previousCandidate;
  return (
    <Modal isOpen={modal} toggle={toggleModal} className="modal-fullscreen modal-dialog-scrollable">
      <If test={candidate === "" || candidate === null}>
        <LoadingModalHeader />
        <LoadingModalBody />
        <Else>
          <ModalHeader>Candidate Information</ModalHeader>
          <ModalBody>
            <CandidateSingleView id={candidate} />
          </ModalBody>
        </Else>
      </If>
      <ModalFooter>
        {/* {previousCandidate === null ? null : (
          <Button
            color="secondary"
            onClick={(e) => {
              setCandidate(previousCandidate);
            }}
          >
            Previous
          </Button>
        )}
        {nextCandidate === null ? null : (
          <Button
            color="secondary"
            onClick={(e) => {
              setCandidate(nextCandidate);
            }}
          >
            Next
          </Button>
        )} */}

        <Button color="danger" onClick={toggleModal}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default CandidateModal;
